document.addEventListener('DOMContentLoaded',function(){

    const $banner = document.querySelectorAll('.banner');

    if(!$banner.length) return

    jQuery('.banner').slick({
        dots: false,
        infinite: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2200,
    });
})